import React, { Component } from "react";
import { Row, Col, Card, CardBody, Button, Label, Container,Spinner, Modal, ModalHeader, ModalBody, FormGroup } from "reactstrap";
import { validateToken } from '../../helpers/jwt-token-access/accessToken'
import { AvForm, AvField } from "availity-reactstrap-validation";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'

import { BaseUrl } from "../../helpers/Baseurl"
import { toTitleCase } from "../../helpers/methods";
import { isEmpty } from "lodash";
import { Link } from "react-router-dom"
import { createSlugfromName, getDifferenceInDays} from "../../helpers/methods";


import HotelsDetail from "../Itinerary/HotelsDetail";
import VehicleDetail from "../Itinerary/VehicleDetail";
import ActivityDetail from "../Itinerary/ActivityDetail";
import PaxDetail from "../Itinerary/PaxDetail";
import DestinationDetail from "../Itinerary/DestinationDetail";
import PackageCost from "../Itinerary/PackageCost";
import ActivityLog from "../Itinerary/ActivityLog";

//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';


const PackegeTypeGroup = [
	{ 
		label: "Packege Type",
		options: [
                { label: "Budget", value: "Budget" },
                { label: "Standard", value: "Standard" },
                { label: "Delux", value: "Delux" },
                { label: "Premium", value: "Premium" },
                { label: "Platinum", value: "Platinum" },
		]
	}
];
const StatusGroup = [
	{ 
		label: "Itinerary Status",
		options: [
                { label: "Processing", value: "processing" },
                { label: "Under Discussion", value: "under discussion" },
                { label: "Tour Booked", value: "tour booked" },
                { label: "Tour In Progress", value: "tour in progress" },
                { label: "Tour Completed", value: "tour completed" },
                
		]
	}
];

class TemplateDetail extends Component {
    constructor(props) {
        super(props);
        this.obj = JSON.parse(localStorage.getItem("authUser"))
        if (!this.obj){
            this.props.history.push('/logout')
        }else if (!validateToken(this.obj.access)){
            this.props.history.push('/logout')
        }
        this.state = {
            
            itinerary:[],
            is_disabled: false,
            loading:false,
            selectedStartDate: null,
            selectedendDate: null,
            LocationsGroup:[],
            DestinationsLocationGroup:[],
            DestinationGroup:[],
            selectedDestinations:[],
            selectedVisitingLocation:[],
            UsersGroup:[],
            selectedPickLocation:{ label: "Select Pickup Location", value: null },
            selectedDropLocation:{ label: "Select Drop Off Location", value: null },
            selectedPackegeType: { label: "Budget", value: "Budget" },
            selectedStatus: { label: "Processing", value: "processing" },
            selectedUser: { label: "", value: "" },
            vehicle_total:0,
            hotel_total:0,
            activity_total:0,
            is_load:false,
        };

        toastr.options = {
            positionClass: "toast-top-right",
            closeButton: "false",
            progressBar: "true",
            showEasing: "swing",
            hideEasing: "linear",
            showMethod: "fadeIn",
            hideMethod: "fadeOut",
            showDuration: 300,
            hideDuration: 1000,
            timeOut: 5000,
            extendedTimeOut: 1000
            }
        
        this.onLocationInputChange = this.onLocationInputChange.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this);
        this.loadDestinationsLocationData = this.loadDestinationsLocationData.bind(this)
        this.SaveItineraryData = this.SaveItineraryData.bind(this)
        this.handleActivityTotal = this.handleActivityTotal.bind(this)
        this.handleHotelTotal = this.handleHotelTotal.bind(this)
        this.handleVehicleTotal = this.handleVehicleTotal.bind(this)
        this.tog_payment_url = this.tog_payment_url.bind(this)
        this.handlePaymentUrlSubmit = this.handlePaymentUrlSubmit.bind(this)
    }

    tog_payment_url() {
        this.setState(prevState => ({
            model_payment_url: !prevState.model_payment_url
        }));
        this.removeBodyCss();
    }

    removeBodyCss() {
        document.body.classList.add("no_padding");
    }
    
    componentDidCatch(){
        this.props.history.push('/templates')
    }

    async componentDidMount() {
        await this.loadDestinationData('?parent=null')
        await this.loadLocationData(`${BaseUrl}/api/locations/location/locations/`)
        await this.loadData()
        await this.loadAllUsersData()
     }

    async loadData(){
    let id = this.props.match.params.id
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        };
    await fetch(`${BaseUrl}/api/itineraries/itineraries/${id}/`,requestOptions)
        .then(res => res.json())
        .then(
            (data) => {
                if(!data.is_template){
                    this.props.history.push(`/itinerary-detail/${data.id}`)
                }
                let itinerary_data = data
                let selectedDestinations = []
                let selectedVisitingLocation = []
                let detinies = itinerary_data.destinations
                for (let i=0; i<detinies.length; i++){
                    selectedDestinations.push({ label: detinies[i].name, value: detinies[i].id })
                }
                let places = itinerary_data.places
                for (let i=0; i<places.length; i++){
                    selectedVisitingLocation.push({ label: places[i].name, value: places[i].id })
                }
                let selectedPickLocation = { label: itinerary_data.pick_up_location.name, value: itinerary_data.pick_up_location.id }
                let selectedDropLocation = { label: itinerary_data.drop_off_location.name, value: itinerary_data.drop_off_location.id }
                let selectedPackegeType =  { label: itinerary_data.packege, value: itinerary_data.packege }
                let selectedStatus = { label: toTitleCase(itinerary_data.status), value: itinerary_data.status }
                let selectedStartDate = new Date(itinerary_data.start_date)
                let selectedendDate = new Date(itinerary_data.end_date)
                let selectedUser =  { label: itinerary_data.created_by.first_name+" "+itinerary_data.created_by.last_name, value: itinerary_data.created_by.id }
                let pax = itinerary_data.pax !==""? itinerary_data.pax: 0 

                let destinations = []
                for(let i=0; i< itinerary_data.destinations.length; i++ ){
                    destinations.push(itinerary_data.destinations[i].id)
                }
                this.loadDestinationsLocationData(destinations.toString())


                this.setState({ itinerary: itinerary_data, selectedPackegeType, selectedPickLocation, selectedVisitingLocation,
                                selectedDropLocation, selectedDestinations, selectedStatus,selectedStartDate,
                                selectedendDate, selectedUser,pax })
                    },
                
            (error) => {
                toastr.error("Somthing Went Wrong")
                this.props.history.push('/templates')
                console.log(error, 'error--------------') 
            }
        )  

    }

    async loadDestinationsLocationData(ids){
        const requestOptions = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
            };
            await fetch(`${BaseUrl}/api/locations/locations/?ids=${ids}`,requestOptions)
                .then(res => res.json())
                .then(
                    (data) => {
                    let options = []
                    data.map(location => {
                        options.push({ label: location.name, value: location.id })
                        })
                    
                        let DestinationsLocationGroup = [
                        { 
                            label: "Locations",
                            options: options
                        }
                    ];
                    this.setState({ DestinationsLocationGroup:DestinationsLocationGroup  }) 
                    },
                    (error) => {
                        console.log(error, 'error--------------') 
                    }
                )  
    }

    async loadAllUsersData(){
            const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json','Authorization': `Bearer ${this.obj.access}`  },
            };
        
            await fetch(`${BaseUrl}/api/accounts/users/`,requestOptions)
            .then(res => res.json())
            .then(
                (data) => {
                    let options = []
                    data.map(user => {
                        options.push({ label: user.first_name+" "+user.last_name, value: user.id })
                        })
                    
                        let UsersGroup = [
                        { 
                            label: "Users",
                            options: options
                        }
                    ];
                    this.setState({ UsersGroup:UsersGroup  })   
                },
                (error) => {
                    console.log(error, 'error--------------')   
                }
            ) 
    }


    async loadDestinationData(filer_queryset){
        const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json','Authorization': `Bearer ${this.obj.access}`  },
        };
        await fetch(`${BaseUrl}/api/locations/location/locations/${filer_queryset}`,requestOptions)
        .then(res => res.json())
        .then(
            (data) => {
                let options = []
                data.results.map(destination => {
                    options.push({ label: destination.name, value: destination.id })
                })
            
                let DestinationGroup = [
                    { 
                        label: "Destination",
                        options: options
                    }
                ];
                this.setState({ DestinationGroup:DestinationGroup  })      
            
            },
            (error) => {
                console.log(error, 'error--------------') 
            }
        )
    }
    
    async loadLocationData(url){
        const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json','Authorization': `Bearer ${this.obj.access}`  },
        };
        await fetch(url, requestOptions)
        .then(res => res.json())
        .then(
            (data) => {
                let options = []
                data.results.map(location => {
                    options.push({ label: location.name, value: location.id })
                })
            
                let LocationsGroup = [
                    { 
                        label: "Locations",
                        options: options
                    }
                ];
                this.setState({ LocationsGroup:LocationsGroup  })
            },
            (error) => {
                console.log(error, 'error--------------') 
            }
        ) 
    }

    // Handle Location Search and call API to filter data 
    onLocationInputChange(e){
        this.loadLocationData(`${BaseUrl}/api/locations/location/locations/?search=${e}`)
    }
    
    handleSelectedPackegeType = selectedPackegeType =>{
        this.setState({ selectedPackegeType })
    }

    handleselectedPickupLocation = selectedPickLocation =>{
        this.setState({ selectedPickLocation })
    }
    
    handleselectedDropOffLocation = selectedDropLocation =>{
        this.setState({ selectedDropLocation })
    }

    handleselectedStartDate = selectedStartDate =>{
        this.setState({ selectedStartDate })
    }

    handleSelectedStatus = selectedStatus =>{
        this.setState({ selectedStatus })
    }

    handleSelectedUser = selectedUser =>{
        this.setState({ selectedUser })
    }


    handleActivityTotal(total){
        this.setState({activity_total : total })
    }

    handleHotelTotal(total){
        this.setState({hotel_total : total })
    }

    handleVehicleTotal(total){
        this.setState({vehicle_total : total })
    }

    // Accept date and Call Update Itinerary API 
    SaveItineraryData(data){
        const {itinerary} = this.state
            const requestOptions = {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
                body: JSON.stringify(data)
                };
                fetch(`${BaseUrl}/api/itineraries/itineraries/${itinerary.id}/`,requestOptions)
                    .then(res => 
                        {if(res.status >= 400){
                            res.json()
                            .then(
                                (data) =>{  
                                    console.log(data, "---data")
                                    toastr.error("Something Went Wrong", "") 
                                    this.setState({ loading: false, add_payment_url_loading:false, model_payment_url:false })
                                }    
                            )
                        }
                        else{
                            this.loadData()
                            this.setState({ loading: false, add_payment_url_loading:false, model_payment_url:false, is_load:true })
                        }    
                    }
                )
    }

    handlePaymentUrlSubmit(e, values){
        this.setState({ add_payment_url_loading: true })
        let data= {"payment_url" : values.payment_url }
        this.SaveItineraryData(data)

    }

    handleSubmit(e, values){
       
        const { selectedDropLocation, selectedPickLocation, selectedStartDate, selectedendDate,selectedPackegeType,
                selectedStatus, selectedUser} = this.state
        if (selectedStartDate === null || selectedendDate === null){
            toastr.error("Please Select Tour Start Date and End Date", "")
        }else if (selectedDropLocation.value === null || selectedPickLocation.value === null){
            toastr.error("Please Select Pick up and Drop Off Location", "")
        }else {
            this.setState({ loading: true })
            let data= {} 
            let dateDiff = getDifferenceInDays(selectedStartDate, selectedendDate)
            let title =values.name+` Tour Package ${dateDiff}N/${dateDiff+1}Day Ex ${selectedPickLocation.label} (${values.customer_name})`
            data["title"] = title
            data["name"] = values.name
            data["customer_name"] = values.customer_name
            data["phone"] = values.phone
            data["email"] = values.email
            data["address"] = values.address+" "+values.address1
            data["zip_code"] = values.zip_code
            data["packege"] = selectedPackegeType.value
            data["start_date"] = `${selectedStartDate.getFullYear()}-${selectedStartDate.getMonth()+1}-${selectedStartDate.getDate()}`
            data["end_date"] = `${selectedendDate.getFullYear()}-${selectedendDate.getMonth()+1}-${selectedendDate.getDate()}`
            data["pick_up_location"]=selectedPickLocation.value
            data["drop_off_location"]=selectedDropLocation.value
            data["created_by"]=selectedUser.value
            data["status"]= selectedStatus.value
            data["pax"]= values.pax
            this.SaveItineraryData(data)          
        }
    }


    render() {
        const { itinerary } = this.state
        let breadcrumbItems = [
            { title: "Templates", link: "/templates" },
            { title: itinerary?itinerary.name:"Itinerary Detail", link: "#" },
        ]
        
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid={true}>
                        <Breadcrumbs breadcrumbItems={breadcrumbItems} />
                        {!isEmpty(this.state.itinerary) ? (
                            <>
                            {/* --------------------------------  Itinerary Section ----------------------------------- */}
                                <Row>
                                    <div className="timeline-block my-3">
                                        <div className="time-show-btn mt-0">
                                            <Link to={`/itinerary-daily-plan/${this.props.match.params.id}`} target="_blank" className="btn btn-link btn-rounded w-lg me-2"><i className="fas fa-clipboard-list font-size-15"></i> Itinerary Plan</Link>
                                            <Link to={`/itinerary/${itinerary.id}/${createSlugfromName(itinerary.name)}`} target="_blank" className="btn btn-link btn-rounded w-lg"><i className="far fa-eye font-size-15"></i> View Itinerary</Link>
                                            {/* <Link to={`/itinerary-terms-&-condition/${this.props.match.params.id}`} target="_blank" className="btn btn-link btn-rounded w-lg me-2"><i className=" far fa-list-alt font-size-15"></i> Terms & Conditions</Link> */}
                                        </div>
                                    </div>
                                </Row>
                                <Row>
                                    <Col lg="12">
                                        <Card>
                                            <CardBody>
                                                <h4 className="card-title mb-4">{itinerary.name} Details</h4>
                                                <AvForm className="needs-validation" id="itinerary" onValidSubmit={this.handleSubmit} >
                                                    <Row>
                                                        <Col md={6}>
                                                            <Row>
                                                                <Col md="6">
                                                                    <div className="mb-3">
                                                                    <Label className="form-label " htmlFor="name">Name</Label>
                                                                    <AvField
                                                                        name="name"
                                                                        value={itinerary.name}
                                                                        type="text"
                                                                        errorMessage="Enter Itinerary Name"
                                                                        className="form-control"
                                                                        validate={{ required: { value: true } }}
                                                                        id="name"   
                                                                    />
                                                                    </div>
                                                                </Col> 
                                                                <Col md="6">
                                                                    <div className="mb-3">
                                                                    <Label className="form-label " htmlFor="customer_name">Customer Name</Label>
                                                                    <AvField
                                                                        name="customer_name"
                                                                        value={itinerary.customer_name}
                                                                        type="text"
                                                                        errorMessage="Enter Customer Name"
                                                                        className="form-control"
                                                                        validate={{ required: { value: true } }}
                                                                        id="customer_name"   
                                                                    />
                                                                    </div>
                                                                </Col> 
                                                            </Row>
                                                        </Col>
                                                        <Col md={6}>
                                                            <Row>
                                                                <Col md={4}>
                                                                    <div className="mb-3">
                                                                        <AvField
                                                                            name="phone"
                                                                            label="Contact Number"
                                                                            value={itinerary.phone}
                                                                            type="text"
                                                                            validate={{
                                                                                required: { value: true },
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </Col>
                                                                <Col md={4}>
                                                                    <div className="mb-3">
                                                                        <Label className="form-label " htmlFor="email">Email</Label>
                                                                        <AvField
                                                                            name="email"
                                                                            value={itinerary.email}
                                                                            type="email"
                                                                            errorMessage="Enter Customer Name"
                                                                            className="form-control"
                                                                            validate={{ required: { value: true } }}
                                                                            id="email"
                                                                        />
                                                                    </div>
                                                                </Col> 
                                                                <Col md={4}>
                                                        
                                                                    <div className="mb-3 form-floating">
                                                                    
                                                                        <AvField
                                                                            name="zip_code"
                                                                            label="Pin/Zip Code"
                                                                            value={itinerary.zip_code}
                                                                            type="number"
                                                                            validate={{
                                                                                pattern: {
                                                                                value: "^[0-9]+$",
                                                                                errorMessage: "Only Digits"
                                                                                }
                                                                            }}
                                                                            />
                                                                    </div>
                                                                </Col>   
                                                            </Row>
                                                        </Col>    
                                                    </Row>
                                                   
                                                    <Row>
                                                        <Col md="6">
                                                            <div className="mb-3">
                                                            <Label className="form-label " htmlFor="address">Address</Label>
                                                            <AvField
                                                                name="address"
                                                                value={itinerary.address}
                                                                type="text"
                                                                errorMessage="Enter Address"
                                                                className="form-control"
                                                                id="address"   
                                                            />
                                                            </div>
                                                        </Col> 
                                                        <Col md="6">
                                                            <div className="mb-3 mt-2">
                                                            <Label className="form-label " htmlFor="address1">{" "}</Label>
                                                            <AvField
                                                                name="address1"
                                                                
                                                                type="text"
                                                                errorMessage="Enter Address"
                                                                className="form-control"
                                                                id="address1"   
                                                            />
                                                            </div>
                                                        </Col> 
                                                        
                                                    </Row>
                                                    <Row>
                                                        <Col md={6}>
                                                            <Row>
                                                                <Col md="4">
                                                                    <div className="mb-3">
                                                                        <Label className="form-label">Packege Type</Label>
                                                                        <Select  
                                                                            value= {this.state.selectedPackegeType}
                                                                            onChange = {this.handleSelectedPackegeType}
                                                                            options={PackegeTypeGroup}
                                                                            classNamePrefix="select2-selection"
                                                                        />
                                                                    </div>
                                                                </Col>
                                                                <Col md="4">
                                                                    <div className="mb-3">
                                                                        <Label className="form-label">Pickup Location</Label>
                                                                        <Select  
                                                                            onInputChange={this.onLocationInputChange}
                                                                            value={this.state.selectedPickLocation}
                                                                            onChange={this.handleselectedPickupLocation}
                                                                            options={this.state.LocationsGroup}
                                                                            classNamePrefix="select2-selection"
                                                                        />
                                                                    </div>
                                                                </Col>
                                                                <Col md="4">
                                                                    <div className="mb-3">
                                                                        <Label className="form-label">Drop off Location</Label>
                                                                        <Select 
                                                                            onInputChange={this.onLocationInputChange}
                                                                            value={this.state.selectedDropLocation}
                                                                            onChange={this.handleselectedDropOffLocation}
                                                                            options={this.state.LocationsGroup}
                                                                            classNamePrefix="select2-selection"
                                                                        />
                                                                    </div>
                                                                </Col>  
                                                    
                                                               
                                                                
                                                            </Row>
                                                        </Col>
                                                        <Col md={6}>
                                                            <Row>
                                                            <Col md="6">
                                                                    <div className="mb-3">
                                                                    <Label className="form-label" htmlFor="start_date">Start Date</Label>
                                                                    <DatePicker
                                                                        className="form-control"
                                                                        minDate={new Date()}
                                                                        selected={this.state.selectedStartDate}
                                                                        onChange={(date) => this.handleselectedStartDate(date)}
                                                                        selectsStart
                                                                        startDate={new Date()}
                                                                        placeholderText="Select Start Date"
                                                                    />
                                                                    </div>
                                                                </Col>                                                                    
                                                                <Col md="6">
                                                                    <div className="mb-3">
                                                                    <Label className="form-label" htmlFor="end_date">End Date</Label>
                                                                    <DatePicker
                                                                        className="form-control"
                                                                        selected={this.state.selectedendDate}
                                                                        onChange={(date) => this.setState({selectedendDate:date})}
                                                                        selectsEnd
                                                                        startDate={this.state.selectedStartDate}
                                                                        minDate={this.state.selectedStartDate}
                                                                        placeholderText="Select End Date"
                                                                    />
                                                                    </div>
                                                                </Col> 
                                                                 
                                                            </Row>
                                                        </Col> 
                                                    </Row>
                                                    <Row>

                                                    </Row>
                                                    <Row>
                                                        <Col md={6}>
                                                            <Row>
                                                                <Col  md={4}>
                                                                    <div className="mb-3">
                                                                        <AvField
                                                                            name="destination_count"
                                                                            label="NO. Of Destinations"
                                                                            type="number"
                                                                            value={this.state.itinerary.destinations?this.state.itinerary.destinations.length:0}
                                                                            disabled
                                                                            />
                                                                    </div>
                                                                </Col>
                                                                
                                                                <Col  md={4}>
                                                                    <div className="mb-3">
                                                                        <AvField
                                                                            name="pax"
                                                                            label="No of Pax"
                                                                            value={this.state.pax}
                                                                            type="number"
                                                                            validate={{
                                                                                pattern: {
                                                                                value: "^[0-9]+$",
                                                                                errorMessage: "Only Digits"
                                                                                }
                                                                            }}
                                                                            />
                                                                    </div>
                                                                </Col>
                                                                <Col  md={4}>
                                                                    
                                                                </Col>

                                                            </Row>
                                                        </Col>
                                                        <Col md={6}>
                                                            <Row>
                                                               
                                                                <Col md={6}>
                                                                    <div className="mb-3">
                                                                        <Label className="form-label">Status</Label>
                                                                        <Select 
                                                                            value={this.state.selectedStatus}
                                                                            onChange={this.handleSelectedStatus}
                                                                            options={StatusGroup}
                                                                            classNamePrefix="select2-selection"
                                                                            
                                                                        />
                                                                    </div>
                                                                </Col>
                                                                <Col md={6}>
                                                                    <div className="mb-3">
                                                                        <Label className="form-label">Assign To</Label>
                                                                        <Select 
                                                                            value={this.state.selectedUser}
                                                                            onChange={this.handleSelectedUser}
                                                                            options={this.state.UsersGroup}
                                                                            classNamePrefix="select2-selection"
                                                                            
                                                                        />
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                        
                                                    </Row>
                                                    {this.obj.user.role === 1 || this.state.itinerary.role === "tour completed"?
                                                        null 
                                                        :
                                                       <Row>
                                                            <Col md="6">
                                                                
                                                            </Col>
                                                            <Col md="6">
                                                                <Row>
                                                                    <Col md="6">
                                                                        
                                                                    </Col>
                                                                    <Col md="6">
                                                                        {this.state.loading?
                                                                            <Spinner className="me-2 mt-3 float-end" color="primary" />
                                                                        :
                                                                            <div className="text-center mt-3 float-end">
                                                                                <Button type="submit" color="primary" className="me-1">
                                                                                    Submit
                                                                                </Button>
                                                                            </div>
                                                                        
                                                                        }
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                        </Row>
                                                    }
                                                        
                                                </AvForm>
                                       
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            {/* --------------------------------  Total Section ----------------------------------- */}
                            <Breadcrumbs title="Package Cost" breadcrumbItems={[]} />

                            <PackageCost
                                data ={this.state.itinerary}
                                hotel_total = {this.state.hotel_total}
                                vehicle_total = {this.state.vehicle_total}
                                activity_total = {this.state.activity_total}
                                SaveItineraryData = {this.SaveItineraryData}
                                user = {this.obj.user}
                                access = {this.obj.access}
                                is_load = {this.state.is_load}

                            />
                            
                            {/* --------------------------------  PAX Section ----------------------------------- */}
                            <Breadcrumbs title="PAX Details" breadcrumbItems={[]} />

                            <PaxDetail
                                data ={this.state.itinerary}
                                user = {this.obj.user}
                                access = {this.obj.access}
                            />

                            {/* --------------------------------  Destination Section ----------------------------------- */}
                                <Breadcrumbs title="Destination Details" breadcrumbItems={[]} />

                                <DestinationDetail
                                    data ={this.state.itinerary}
                                    DestinationGroup = {this.state.DestinationGroup}
                                    SaveItineraryData = {this.SaveItineraryData}
                                    user = {this.obj.user}
                                    access = {this.obj.access}

                                />

                            

                            {/* --------------------------------  Hotels Section ----------------------------------- */}
                                <Breadcrumbs title="Hotel Details" breadcrumbItems={[]} />

                                <HotelsDetail
                                    data ={this.state.itinerary}
                                    handleHotelTotal = {this.handleHotelTotal}
                                    user = {this.obj.user}
                                    access = {this.obj.access}
                                    history = {this.props.history}
                                />

                                {/* --------------------------------  Vehicle Section ----------------------------------- */}
                                
                                <Breadcrumbs title="Vehicle Details" breadcrumbItems={[]} />

                                <VehicleDetail
                                    data ={this.state.itinerary}
                                    DestinationGroup = {this.state.DestinationGroup}
                                    handleVehicleTotal = {this.handleVehicleTotal}
                                    user = {this.obj.user}
                                    obj = {this.obj}
                                    history = {this.props.history}
                                    
                                />

                                {/* --------------------------------  Vehicle Section ----------------------------------- */}
                                <Breadcrumbs title="Activity Details" breadcrumbItems={[]} />

                                <ActivityDetail
                                    data ={this.state.itinerary}
                                    location = {this.state.DestinationsLocationGroup}
                                    handleActivityTotal = {this.handleActivityTotal}
                                    user = {this.obj.user}
                                    access = {this.obj.access}
                                    history = {this.props.history}
                                />


                                {/* --------------------------------  Activitry Section ----------------------------------- */}
                               
                                <ActivityLog
                                    itinerary ={this.state.itinerary}
                                    user = {this.obj.user}
                                    access = {this.obj.access}
                                    history = {this.props.history}
                                /> 
                            </>
                        ):(
                            <div className="d-flex align-items-center justify-content-center min-vh-100">
                    
                                <Spinner type="grow" className="me-2" color="secondary" />
                                <Spinner type="grow" className="me-2" color="secondary" />
                                <Spinner type="grow" className="me-2" color="secondary" />
                                <Spinner type="grow" className="me-2" color="secondary" />
            
                            </div>
                        )}

                    </Container>
                </div>
                <Col sm={6} md={4} xl={3} className="mt-4">
               
                    <Modal
                    isOpen={this.state.model_payment_url}
                    toggle={this.tog_payment_url}
                    centered={true}
                    >
                        <ModalHeader toggle={this.tog_payment_url}>
                        Online Payment Url
                        </ModalHeader>
                        <ModalBody>
                            <AvForm className="needs-validation" onValidSubmit={this.handlePaymentUrlSubmit} >
                                    <Row>
                                       
                                        <Col md="12">
                                            <div className="mb-3">
                                            <Label className="form-label" htmlFor="payment_url">{"Online Paymant Url"}</Label>
                                            <AvField
                                                name="payment_url"
                                                type="text"
                                                placeholder="Enter Online Payment URL"
                                                value ={itinerary.payment_url}
                                                className="form-control"
                                                validate={{ required: { value: true } }}
                                                id="payment_url"   
                                            />
                                            </div>
                                        </Col>  
                                    </Row>
                               
                                                
                                <FormGroup className="mb-0 mt-3">
                                {this.state.add_payment_url_loading?(
                                    <Spinner className="me-2 mt-2" color="primary" />
                                ):(
                                <Button type="submit" color="primary" className="me-1">
                                    Save
                                </Button>
                               
                                    )}
                                </FormGroup>     
                            </AvForm>

                        </ModalBody>
                    </Modal>
                </Col>
            </React.Fragment>
        );
    }
}

export default TemplateDetail;